import { StyleSheet } from 'aphrodite';
import { background, brandPrimary, brandSecondary, charmGray, shuffleGray, titles } from '../../../web/styles/colors';

export const s = StyleSheet.create({
	bold: {
		fontWeight: 'bold',
	},
	checkboxContainer: {
		flexBasis: '50%',
		marginBottom: 16,
	},
	checkboxes: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	container: {
		padding: 8,
		width: 600,
		boxSizing: 'border-box',
	},
	// v2 Dialog overrides: let the popup control the width and the content fill it, so nothing
	// overflows the (narrower, padded) DialogPopup the way the fixed 600px container would.
	dialogPopup: {
		maxWidth: 640,
		width: '100%',
	},
	dialogContainer: {
		width: '100%',
	},
	// Make the components-v2 Dropdown triggers fill the field width (they default to fit-content).
	fullTrigger: {
		width: '100%',
		overflow: 'hidden',
	},
	dropdownContent: {
		maxHeight: 320,
		overflowY: 'auto',
	},
	checkboxRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: 8,
		marginBottom: 16,
	},
	checkboxLabel: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	content: {
		overflow: 'auto',
		maxHeight: 512,
	},
	newContentCheckbox: {
		marginBottom: 16,
	},
	rowContainer: {
		display: 'flex',
		marginTop: 24,
		gap: 8,
	},
	saveBtn: {
		flex: 1,
	},
	text: {
		fontSize: 14,
		paddingLeft: 12,
		width: 250,
	},
	header: {
		color: titles,
		fontSize: '1.125rem',
		margin: `0 0 24px 0`,
	},
	title: {
		color: brandSecondary,
		fontSize: '1.125rem',
		margin: 0,
		marginBottom: 8,
	},
	optOut: {
		color: brandSecondary,
		fontSize: '1.125rem',
		margin: 0,
		marginBottom: 8,
	},
	option: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	separator: {
		marginBottom: 32,
	},
	aboutBiz: {
		color: brandPrimary,
		marginBottom: 8,
		fontSize: '1rem',
	},
	subverticalSubtext: {
		boxSizing: 'border-box',
		padding: 0,
		margin: 0,
		color: charmGray,
		fontSize: '0.75rem',
		marginBottom: 16,
	},
	optOutSubtext: {
		boxSizing: 'border-box',
		padding: 0,
		margin: 0,
		color: charmGray,
		fontSize: '0.75rem',
		marginBottom: 16,
	},
	bizDesc: {
		boxSizing: 'border-box',
		padding: 0,
		margin: 0,
		color: charmGray,
		fontSize: '0.75rem',
		marginBottom: 16,
	},
	inputAboutBiz: {
		width: '100%',
		marginBottom: 16,
		backgroundColor: background,
		border: `1px solid ${shuffleGray}`,
		height: 204,
		padding: `12px 16px`,
		boxSizing: 'border-box',
		resize: 'none',
	},
	mprefTitle: {
		fontSize: `1.125rem`,
		color: titles,
		marginBottom: 24,
	},
	formality: {
		marginBottom: 32,
	},
	spinnerContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	selectedMultiOption: {
		width: '100%',
	},
	multiselectContainer: {
		marginBottom: 24,
	},
});
